module.exports = __webpack_public_path__ + "img/money-light.88483434.svg";